import { FC, useEffect } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

export interface Props extends ReactModalProps {
  closeButton?: boolean;
}

const Modal: FC<Props> = ({ children, style, preventScroll, closeButton, className = '', ...props }) => {
  const [isDesktopSize] = useMediaQuery(desktop);

  const modalStyle: ReactModalProps['style'] = {
    overlay: {
      zIndex: 51,
      backgroundColor: 'rgba(127 ,127, 127, .3)',
      overflowY: 'auto',
      ...style?.overlay,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      maxWidth: isDesktopSize ? 800 : '90%',
      height: '400px',
      backgroundColor: 'white',
      position: 'relative',
      padding: '20px',
      overflowY: 'auto',
      ...style?.content,
    },
  };

  useEffect(() => {
    if (preventScroll && props.isOpen) {
      // Keep scrollbar visible, no need to hide it
      document.body.style.overflow = 'auto'; // Ensure overflow is set to auto
      document.body.style.paddingRight = '0px'; // No padding adjustment needed
    }

    return () => {
      document.body.style.overflow = 'auto'; // Reset overflow when modal closes
      document.body.style.paddingRight = '0px'; // Reset any potential padding
    };
  }, [props.isOpen, preventScroll]);

  return (
    <ReactModal
      {...props}
      ariaHideApp={false}
      style={modalStyle}
      preventScroll={preventScroll}
      className={`${className} relative`}
    >
      {closeButton && (
        <div className="absolute right-20 top-20 flex cursor-pointer items-center" onClick={props.onRequestClose}>
          <span className="mr-2 text-14 font-bold text-secondary-black ">Close</span>
          <CloseIcon className="h-18 w-18 pt-3 font-bold text-red-600" />
        </div>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
